"use client";

import { Panel, PanelGroup } from "react-resizable-panels";
import { DevPanel } from "./DevPanel";

export const LayoutPanelWrapper = ({
  children,
  isDevPanel,
}: {
  children: React.ReactNode;
  isDevPanel: boolean;
}) => {
  return (
    <PanelGroup direction="horizontal" className="h-full">
      <Panel id="sidebar">
        <div className="relative w-full flex-1">{children}</div>
      </Panel>
      {isDevPanel && <DevPanel />}
    </PanelGroup>
  );
};
